export default "__VITE_ASSET__otxgcQ9t__"